
import React, {Component} from 'react'
import { ClipLoader } from 'react-spinners'
import { css } from '@emotion/core';
//import './DailyOpinionBox.css'

var parse = require('html-react-parser');
const override = "display: block;margin: auto auto;border-color: red; width: 100px; height: 100px;"


var isBoxDragging = false;
export default class DailyOpinionBox extends Component{

    constructor(){
        super();
        this.state = {
            transform: [0, 0]
        }
        
        this.dragPrevPos = [0, 0];

    }

    handleDragStart = (e) => {

        
        console.log(e.target.id);
        
        e.dataTransfer.setDragImage(document.getElementById('blank-div'), 0, 0);
        if(e.target.id === 'box-header')
        {
            isBoxDragging = true;
            e.dataTransfer.setData('text/plain', null);
            this.dragPrevPos[0] = e.clientX;
            this.dragPrevPos[1] = e.clientY;
        }
    
      }

    componentDidMount(){
        document.getElementById('content').addEventListener('dragover', function(e) {
            if(isBoxDragging == true)
            {
                window.opinionBox.handleDrag(e);
                e.stopPropagation();
                e.preventDefault();
            }
        }, false);

        document.addEventListener('touchmove', function(e) {
            if(isBoxDragging)
                e.preventDefault(); 
        }, { passive:false 
        });
    }

    handleDrag = (e) => {
        
        if(e.clientX == this.dragPrevPos[0] && e.clientY == this.dragPrevPos[1])
            return;
        
        if(e.clientX == 0 || e.clientY == 0)
            return;

        let { transform } = this.state;

        transform[0] += e.clientX - this.dragPrevPos[0];
        transform[1] += e.clientY - this.dragPrevPos[1];

        this.dragPrevPos[0] = e.clientX;
        this.dragPrevPos[1] = e.clientY;
        
        this.setState({ transform });
        
    }

    handleTouchStart = (event) => {
        console.log(event.target.id);
        if(event.target.id === 'box-header')
        {
            let e = event.targetTouches[0];
            this.dragPrevPos[0] = e.clientX;
            this.dragPrevPos[1] = e.clientY;
            isBoxDragging = true;
        }

    }

    handleTouchMove = (event) => {

        if(isBoxDragging == true)
        {
            let e = event.targetTouches[0];
            
            if(e.clientX == 0 || e.clientY == 0)
                return;

            let { transform } = this.state;

            transform[0] += e.clientX - this.dragPrevPos[0];
            transform[1] += e.clientY - this.dragPrevPos[1];

            this.dragPrevPos[0] = e.clientX;
            this.dragPrevPos[1] = e.clientY;

            this.setState({ transform });
        }
    }

    handleDragEnd = () => {
        isBoxDragging = false;
    }

    render(){
        
        const data = this.props.data;
        if(data == null)
            return(
                <div className="box-container draggable" style={{ left: this.props.pos[0], top: this.props.pos[1], transform: "translate(" + this.state.transform[0] + "px, " + this.state.transform[1] + "px)" }} draggable={true} onDragStart={e => this.handleDragStart(e)} onTouchStart={this.handleTouchStart} onTouchMove={this.handleTouchMove} id="opinion-box" onTouchEnd={this.handleDragEnd} onDrop={this.handleDragEnd} >
                <div className="box-header" id="box-header" draggable={true}>
                    <div className="opinion-symbol-container">
                        { this.props.symbol }
                    </div>
                    <div className="nav-container">
                        <span className="btn-nav" >
                            &lt; Prev
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span className="btn-nav" >
                            Next &gt;
                        </span>
                    </div>
                    <i className="fas fa-times close-icon" onClick={this.props.handleClickClose}></i>
                </div>
                    <div style={ {margin: "auto auto", display: "flex", paddingTop: "100px"}}>
                    <ClipLoader  
                        css={override} 
                        sizeUnit={"px"}
                        size={25}
                        color={'#123abc'}
                        loading={true}
                    />
                    </div>
                </div>
            )
        return (
           <div className="box-container draggable" style={{ left: this.props.pos[0], top: this.props.pos[1], transform: `translate(${this.state.transform[0]}px, ${this.state.transform[1]}px)` }} draggable={true} onDragStart={e => this.handleDragStart(e)} onTouchStart={this.handleTouchStart} onTouchMove={this.handleTouchMove} id="opinion-box" >
                <div className="box-header" id="box-header" draggable={true} >
                    <div className="opinion-symbol-container">
                        { this.props.symbol }
                    </div>
                    <div className="nav-container">
                        <span onClick={e => this.props.handleClickPrev(data.date)} className="btn-nav" >
                            &lt; Prev
                        </span>
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                        <span onClick={e => this.props.handleClickNext(data.date)} className="btn-nav" >
                            Next &gt;
                        </span>
                    </div>
                    <i className="fas fa-times close-icon" onClick={this.props.handleClickClose}></i>
                </div>
                <div className="opinion-box-container">
                    <div className="opinion-label-container">
                    Date: { data.date }
                    </div>
                    <div className="opinion-label-container">
                    { data.opiniondailylabel }
                    </div>
                    <div style={{color: data.opiniondailycolor, fontWeight: 700}}>
                    { data.opiniondaily }
                    </div>
                    <div className="detail-container">
                        { parse(data.opiniondailydetail) }
                    </div>

                    <div className="opinion-label-container">
                        { data.opinionshortlabel }
                    </div>
                    <div style={{ color: data.opinionshorttermcolor, fontWeight: 700 }}>
                        { data.opinionshortterm }
                    </div>
                    <div className="detail-container">
                        { parse(data.opinionshorttermdetail) }
                    </div>

                    <div className="opinion-label-container">
                        { data.opinionlongtermlabel }
                    </div>
                    <div style={{ color: data.opinionlongtermcolor, fontWeight: 700 }}>
                        { data.opinionlongterm }
                    </div>
                    <div className="detail-container">
                        { parse(data.opinionlongtermdetail) }
                    </div>
                </div>
           </div>
       ) 
    }
}